module.exports = __webpack_public_path__ + "img/p1-desc.293e0cd1.jpg";